// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2PJwk","rootSuccess":"CompleteLink_rootSuccess__3KrbB","rootFailure":"CompleteLink_rootFailure__1tjx7","isDisabled":"CompleteLink_isDisabled__3C1mh"};